import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../features/auth/store';
import type { Role } from '../shared/types';

interface Props {
  allow?: Role[];
  children: ReactNode;
}

export default function RoleGuard({ allow, children }: Props) {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.accessToken);
  if (!user || !token) return <Navigate to="/login" replace />;
  if (user.mustResetPassword && window.location.pathname !== '/portal/change-password') {
    return <Navigate to="/portal/change-password" replace />;
  }
  if (allow && !allow.includes(user.role)) return <Navigate to="/portal" replace />;
  return <>{children}</>;
}
